<app-loader *ngIf="showLoading"></app-loader>
<form>
    <div class="main-wrapper">
        <app-header> </app-header>
        <app-leftmenu></app-leftmenu>
        <div class="page-wrapper">
            <div class="content container-fluid">
                <!-- Page Header -->
                <div class="page-header">
                    <div class="row align-items-center">
                        <div class="col">
                            <h3 class="page-title">{{PageTitle}}</h3>
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a routerLink="/Dashboard"> Dashboard</a>
                                </li>
                                <li class="breadcrumb-item active">{{PageTitle}}</li>
                            </ul>
                        </div>

                        <div class="col-auto float-right ml-auto">
                            
                            <button mat-flat-button color="accent" (click)="addPoPayment()">
                                <mat-icon aria-hidden="false">add</mat-icon> Add PO Payment
                            </button>
                            <button mat-flat-button color="warn" (click)="goBack()">
                                <mat-icon aria-hidden="false">add</mat-icon> Back
                            </button>

                        </div>





                    </div>
                </div>
                <!-- /Page Header -->


                <div class="tab-content">

                    <!-- Add Family -->
                    <div class="pro-overview tab-pane fade show active">
                        <div class="card">


                            <!-- Search Table -->
                            <div class="total-rec">Total Records: {{totalRecords}}</div>

                            <table mat-table [dataSource]="PoPaymentMasterData" matSort class="mat-elevation-z8">

                                <!--  Schedule Date Column -->
                                <ng-container matColumnDef="scheduleDate">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Schedule Date</th>
                                    <td mat-cell *matCellDef="let PoPaymentMasterData ">
                                        {{PoPaymentMasterData.scheduleDate | date : 'dd/MM/yyyy'}}
                                    </td>
                                </ng-container>

                                <!--  amount Column -->
                                <ng-container matColumnDef="amount">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount</th>
                                    <td mat-cell *matCellDef="let PoPaymentMasterData ">
                                        {{PoPaymentMasterData.amount}}
                                    </td>
                                </ng-container>
                                 <!--  paymentMode Column -->
                                 <ng-container matColumnDef="paymentMode">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Payment Mode</th>
                                    <td mat-cell *matCellDef="let PoPaymentMasterData ">
                                        {{PoPaymentMasterData.paymentMode}}
                                    </td>
                                </ng-container>

                                <!--  paymentDate Column -->
                                <ng-container matColumnDef="paymentDate">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Payment Date</th>
                                    <td mat-cell *matCellDef="let PoPaymentMasterData ">
                                        {{PoPaymentMasterData.paymentDate | date : 'dd/MM/yyyy'}}
                                    </td>
                                </ng-container>

                                 <!--  Invoice Number Column -->
                                 <ng-container matColumnDef="invoiceNumber">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Number</th>
                                    <td mat-cell *matCellDef="let PoPaymentMasterData ">
                                        {{PoPaymentMasterData.invoiceNumber}}
                                    </td>
                                </ng-container>

                                 <!--  Invoice Date Column -->
                                 <ng-container matColumnDef="invoiceDate">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Date</th>
                                    <td mat-cell *matCellDef="let PoPaymentMasterData ">
                                        {{PoPaymentMasterData.invoiceDate | date : 'dd/MM/yyyy'}}
                                    </td>
                                </ng-container>


                                <!-- Action Column -->
                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef> Action </th>
                                    <td mat-cell *matCellDef="let PoPaymentMasterData">

                                        <a mat-flat-button color="primary" matTooltip="Edit this record"
                                            [routerLink]="['/searchPurchaseOrder/EditPoPayment', PoPaymentMasterData.entityId,'edit']"
                                            title="Edit">
                                            <mat-icon aria-hidden="false">edit</mat-icon>
                                        </a>

                                        <button mat-flat-button color="warn" matTooltip="Delete this record" (click)="deletePayment(PoPaymentMasterData.entityId)"
                                            title="Delete">
                                            <mat-icon aria-hidden="false">delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                            <mat-paginator [pageSize]="pageSizedisplay" [pageSizeOptions]="itemPerPage"
                                showFirstLastButtons>
                            </mat-paginator>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>